import * as types from './actionTypes';  
import saveAllocationApi from '../api/saveAllocationApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doSaveAllocation(request) {

  return {
    type: types.DO_SAVE_ALLOCATION, 
    request
  };
}

export function doSaveAllocationRes(data) {  
  return {
    type: types.DO_SAVE_ALLOCATION_RES, 
    data
  };
}
export function saveAllocation(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      saveAllocationApi.doSaveAllocation(request).then(data => {
        dispatch(doSaveAllocationRes(data));
        dispatch(doSaveAllocationRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}